import { LiliCheckboxNew, LiliTextArea, Text } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { ControllerWrapper } from '@Hooks/index';
import { EddEmbeddedFields } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/fields.types';
import { BusinessCapitalOptions } from './hooks/useBusinessCapitalLogic';

interface BusinessCapitalFormProps {
  reactiveOptions: string[];
  optionsList: {
    value: string;
    getLabel: () => string;
  }[];
}

export const BusinessCapitalForm = ({
  reactiveOptions = [],
  optionsList,
}: BusinessCapitalFormProps) => {
  const { t } = useTranslation('eddQuestions');

  const isOtherSelected = reactiveOptions.includes(BusinessCapitalOptions.OTHER);

  return (
    <div className='flex flex-col gap-4'>
      <ControllerWrapper name={EddEmbeddedFields.EDD_BUSINESS_CAPITAL_SOURCE}>
        {({ onChange }) => {
          const handleOnChange = (option: BusinessCapitalOptions) => {
            if (reactiveOptions.includes(option)) {
              onChange(reactiveOptions.filter((item) => item !== option));
            } else {
              onChange([...reactiveOptions, option]);
            }
          };

          return (
            <>
              {optionsList.map((option) => (
                <LiliCheckboxNew
                  key={option.value}
                  id={option.value}
                  checked={reactiveOptions.includes(option.value)}
                  onCheckedChange={() => handleOnChange(option.value as BusinessCapitalOptions)}
                  label={
                    <Text.H10 className='text-text-main-secondary'>{option.getLabel()}</Text.H10>
                  }
                  labelAlign='center'
                />
              ))}
            </>
          );
        }}
      </ControllerWrapper>

      {isOtherSelected && (
        <ControllerWrapper name={EddEmbeddedFields.EDD_BUSINESS_CAPITAL_SOURCE_OTHER_FREE_TEXT}>
          {({ onChange, value, error, onBlur }) => (
            <LiliTextArea
              value={value}
              onValueChange={onChange}
              errorMsg={error?.message || ''}
              externalErrorMessage={error?.message || ''}
              maxLength={100}
              minHeight='min-h-[88px]'
              placeholder={t('organic.businessCapital.otherPlaceholder')}
              onBlur={onBlur}
            />
          )}
        </ControllerWrapper>
      )}
    </div>
  );
};
